import { Table } from "@kanda-libs/ks-component-ts";
import { ExpandableContent } from "@kanda-libs/ks-design-library";
import type { FunctionComponent } from "react";
import useCompanyRatesTableProps from "./useCompanyRatesTableProps";

const CompanyRatesNew: FunctionComponent = function () {
  const tableProps = useCompanyRatesTableProps();

  return (
    <ExpandableContent
      compact
      showLabel="Show company rates"
      hideLabel="Hide company rates"
    >
      <Table {...tableProps} />
    </ExpandableContent>
  );
};

export default CompanyRatesNew;
